function _createForOfIteratorHelperLoose(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (it) return (it = it.call(o)).next.bind(it); if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; return function () { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import isPlainObject from 'lodash/isPlainObject';
import get from 'lodash/get';
var VisualEngine = window.VisualEngine;
function isDesignMode(props) {
  var mode;
  if (isPlainObject(props)) {
    mode = props === null || props === void 0 ? void 0 : props.__designMode;
  } else if (typeof props === 'string') {
    mode = props;
  }
  return mode === 'design';
}
function executeFunction(func) {
  if (typeof func === 'function') {
    var result;
    try {
      for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        rest[_key - 1] = arguments[_key];
      }
      result = func.apply(void 0, rest);
    } catch (e) {}
    return result;
  }
}
function getLowCodeCoreUtil(path) {
  return get(window.cnLowCodeUtils, path);
}
function isArrayNotEmpty(list) {
  return Array.isArray(list) && list.length > 0;
}
function hasCnLayoutPage() {
  var _VisualEngine$designe, _VisualEngine$designe2, _nodesMap$values;
  var nodesMap = VisualEngine === null || VisualEngine === void 0 ? void 0 : (_VisualEngine$designe = VisualEngine.designer) === null || _VisualEngine$designe === void 0 ? void 0 : (_VisualEngine$designe2 = _VisualEngine$designe.currentDocument) === null || _VisualEngine$designe2 === void 0 ? void 0 : _VisualEngine$designe2.nodesMap;
  var flag = false;
  if (nodesMap !== null && nodesMap !== void 0 && (_nodesMap$values = nodesMap.values) !== null && _nodesMap$values !== void 0 && _nodesMap$values.call(nodesMap)) {
    for (var _iterator = _createForOfIteratorHelperLoose(nodesMap === null || nodesMap === void 0 ? void 0 : nodesMap.values()), _step; !(_step = _iterator()).done;) {
      var item = _step.value;
      if ((item === null || item === void 0 ? void 0 : item.componentName) === 'CnLayoutPage') {
        flag = true;
        break;
      }
    }
  }
  return flag;
}
export { isDesignMode, executeFunction, getLowCodeCoreUtil, isArrayNotEmpty, hasCnLayoutPage };